export const formatDate = (fullDate) => {
    const date = new Date(fullDate);
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
};
